import { render, staticRenderFns } from "./DeterPantanal.vue?vue&type=template&id=6c057278&lang=pug"
import script from "./DeterPantanal.vue?vue&type=script&lang=js"
export * from "./DeterPantanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports